module.exports = __webpack_public_path__ + "static/img/170810-resaerch-team-photo.e5bd4e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170810-resaerch-team-photo.jpg
// module id = 8jGi
// module chunks = 0